/**
 * What to tell someone whose sign-in could not reach the server.
 *
 * Says what to do rather than what went wrong, and is explicit that the
 * credentials were not the problem — otherwise a student spends the outage
 * retyping a password that was right all along.
 */
export const AUTH_UNREACHABLE_MESSAGE =
  'We could not reach the sign-in server. This is not a problem with your details — check your connection and try again in a moment.';

/**
 * Did this auth call fail because the server was unreachable, rather than
 * because the credentials were wrong?
 *
 * auth-js labels every transport-level failure `AuthRetryableFetchError` — a
 * dropped connection, a 5xx, one of Cloudflare's 520-530 codes, and the
 * deadline in `lib/auth-fetch.ts`. Matching on the name keeps this free of a
 * direct dependency on the transitive `@supabase/auth-js` package.
 */
export function isAuthConnectionError(error: { name?: string } | null | undefined): boolean {
  return error?.name === 'AuthRetryableFetchError';
}
